import { FormField } from "components/form/FormField/FormField";
import { Select } from "components/ui/Select/Select";

import style from "../ReferralForm.module.css";

export const LifeStyleAndSocialHistoryFormSection = ({
  form,
  isLungReferral,
}) => {
  return (
    <div className={style.itemWrapper}>
      <div className={style.inputGroupGrid3Columns}>
        <FormField name="drinker">
          <label className={style.addReferralFormLabel}>Drinker</label>
          <Select
            options={[
              {
                label: "Yes",
                value: "true",
              },
              {
                label: "No",
                value: "false",
              },
              {
                label: "Unknown",
                value: "unknown",
              },
            ]}
            value={form.watch("drinker")}
            fullWidth
            onChange={(value) => form.setValue("drinker", value)}
            required
          />
        </FormField>
        <FormField name="smoker">
          <label className={style.addReferralFormLabel}>
            Smoker {isLungReferral && <span>*</span>}
          </label>
          <Select
            options={[
              {
                label: "Current Smoker",
                value: "CURRENT_SMOKER",
              },
              {
                label: "Former Smoker",
                value: "EX_SMOKER",
              },
              {
                label: "Non Smoker",
                value: "NON_SMOKER",
              },
              {
                label: "Unknown",
                value: "UNKNOWN",
              },
            ]}
            value={form.watch("smoker")}
            fullWidth
            onChange={(value) => form.setValue("smoker", value)}
            required
          />
        </FormField>

        <FormField name="nextOfKin">
          <label className={style.addReferralFormLabel}>
            Next of Kin (name, contact no. & relationship)
          </label>
          <input
            type="text"
            className="form-control"
            {...form.register("nextOfKin")}
          />
        </FormField>
      </div>
      {(form.watch("drinker") === "true" ||
        form.watch("smoker") === "CURRENT_SMOKER" ||
        form.watch("smoker") === "EX_SMOKER") && (
        <div
          className={style.inputGroupGrid3Columns}
          style={{ marginTop: "24px" }}
        >
          <div>
            {form.watch("drinker") === "true" && (
              <FormField name="unitsOfAlcohol">
                <label className={style.addReferralFormLabel}>
                  Units of Alcohol
                </label>
                <div className={style.perWeekInput}>
                  <input
                    type="text"
                    className="form-control"
                    {...form.register("unitsOfAlcohol")}
                  />
                </div>
              </FormField>
            )}
          </div>
          <div className={style.inputGroupGrid2Columns}>
            {(form.watch("smoker") === "CURRENT_SMOKER" ||
              form.watch("smoker") === "EX_SMOKER") && (
              <>
                <FormField name="numberOfCigarettes">
                  <label className={style.addReferralFormLabel}>
                    Number of Cigarettes
                  </label>
                  <div className={style.perDayInput}>
                    <input
                      type="text"
                      inputMode="numeric"
                      className="form-control"
                      onInput={(e) =>
                        (e.target.value = e.target.value.replace(/[^0-9]/g, ""))
                      }
                      {...form.register("numberOfCigarettes")}
                    />
                  </div>
                </FormField>
                <FormField name="yearsSmoking">
                  <label className={style.addReferralFormLabel}>
                    Years Smoking
                  </label>
                  <input
                    type="text"
                    inputMode="numeric"
                    onInput={(e) =>
                      (e.target.value = e.target.value.replace(/[^0-9]/g, ""))
                    }
                    className="form-control"
                    {...form.register("yearsSmoking")}
                  />
                </FormField>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};
